module.exports = __webpack_public_path__ + "static/media/seal-of-transparency.1a60f6e8.png";